import {
  observable,
  transaction,
  map,
  computed,
  reaction,
  runInAction,
  action,
  toJS
} from 'mobx';
import QueryApi from './api';
import columnStore from './columnStore';
import tools from '../../utils/tools';
import { dateTimePicker } from 'mutants-jsbridge';
import { tools as vTools} from 'tplus-voucher';

class RefModel {
  @observable data = [];
  @observable pageIndex = 0;
  @observable totalPageNum = 1;
  @observable searchValue = '';
  @observable IsNextPage = true;
  @observable title = '';
  @observable showField = [{ name: '编码', field: 'Code' }, { name: 'Id', field: 'Id' }];

  @observable selecteds = [];

  @observable loaded = true;
  @observable error = null;

  @observable multiSelect = false;

  @observable localSearch = false;
  @observable EnumName = false;
  @observable FieldType = '';
  @observable FieldName = '';
  @observable isCustomize = false; // 是否是自定义项
  @observable RefTitleInfo = [];
  @observable notShowIdOrCode = [];
  desensitizationFileds = []; //脱敏显示字段

  refRequestMethord = '';
  refRequestParam = {};
  refreshVersion = 1;

  @computed get displayData() {
    let _displayData;
    if (this.isCustomize) { // 如果是自定义项

      _displayData = toJS(this.data).map(item => {
        let obj = {};
        this.RefTitleInfo.forEach((it, i) => {
          obj[it] = item[i];
        })
        return obj
      })
      if (this.EnumName) {
        _displayData = _displayData.filter(item => {
          return item.returnValue.indexOf(this.searchValue.trim()) >= 0;
        })
      }
    } else if (this.EnumName) { // 如果是枚举
      if (this.searchValue.trim()) {
        _displayData = toJS(this.data).filter(item => item.Name.indexOf(this.searchValue.trim()) != -1);
      } else {
        _displayData = toJS(this.data);
      }
    } else {
      _displayData = toJS(this.data);
    }
    _displayData.unshift({ Name: '清空', Id: '', Code: '', clear: true });
    this.setIsSelect(_displayData);
    return _displayData;
  }

  @computed get hasMore() {
    if (this.EnumName) { // 如果是枚举 就没有加载更多
      return false;
    }
    if (this.isCustomize) { // 如果是自定义项 就判断 IsNextPage
      return this.IsNextPage;
    }
    if (this.pageIndex > this.totalPageNum - 1) { // 如果是参照，就判断 页数
      return false;
    }
    return true;
  }

  @action select(value) {
    if (!this.multiSelect) {
      this.selecteds = [value];
    } else {
      let index = -1;
      this.selecteds.forEach((selected, position) => {
        if ((selected.ID && selected.ID == value.ID) ||
          (selected.Id && selected.Id == value.Id)) {
          index = position;
        }
      })
      index >= 0 ? this.selecteds.splice(index, 1) : this.selecteds.push(value);
    }
  }

  clearSelecteds = () => {
    runInAction(() => {
      this.selecteds = [];
    });

  }


  @action async load({
    multiSelect,
    searchValue = '',
    EnumName,
    FieldType,
    Title,
    FieldName,
    notShowIdOrCode = [],
    ...opt
  }) {
    this.loaded = false;
    this.multiSelect = multiSelect;
    this.selecteds = opt.selecteds && opt.selecteds.length > 0 ? opt.selecteds : this.selecteds;
    this.searchValue = searchValue;
    this.EnumName = EnumName;
    this.FieldType = FieldType;
    this.FieldName = FieldName;
    this.pageIndex = 0;
    this.totalPageNum = 1; // 这里不要设置0
    this.opt = opt;
    this.title = Title;
    this.notShowIdOrCode = notShowIdOrCode;
    if (this.opt.refRequestMethord) {
      this.refRequestMethord = this.opt.refRequestMethord;
      this.refRequestParam = this.opt.refRequestParam;
    }

    const result = await this.loadNext(this.opt.scanCode || '');

    runInAction(() => {
      this.loaded = true;
    });

    return result;
  }

  getDesensitizationInfo = async (id,field) => {
    const param = { id, field , dtoname: this.opt.RefDTOName}
    const resp = await vTools.showOrign(param);
    runInAction(() => {
      this.data.forEach(item=>{
        if(item.ID == id){
          item[field] = resp;
        }
      })
      this.refreshVersion++;
    });
  }


  @action async loadNext(searchValue = '') {

    if (this.searchValue !== searchValue) {
      this.pageIndex = this.isCustomize ? 1 : 0;
      this.totalPageNum = this.isCustomize ? 1 : 0;
      this.IsNextPage = true;
    }
    this.searchValue = searchValue;

    if (!this.isCustomize && this.EnumName && !this.opt.scanCode && this.pageIndex >= this.totalPageNum) {
      return;
    }

    // 自定义项 枚举 判断IsNextPage 参照 判断 totalPage
    if (!this.IsNextPage && (this.isCustomize || this.EnumName)) {
      return;
    }
    let data;

    // FieldName 以 下面几项开头的，就是自定义项
    const customFieldPrefixArray = ['priuserdefnvc', 'priuserdefdecm', 'pubuserdefnvc', 'pubuserdefdecm'];

    customFieldPrefixArray.forEach(item => {
      if (this.FieldName && this.FieldName.startsWith(item)) {
        this.isCustomize = true;
      }
    })


    try {
      if (this.isCustomize) { // 自定义项
        if (this.pageIndex == 0) {
          this.pageIndex = 1; // 自定义项 从第1页开始
        }
        data = await QueryApi.GetVoucherEnumOrRefSetItem({
          "KeyWord": this.searchValue,
          "PageSize": 10,
          "PageIndex": this.pageIndex,
          "RefKey": JSON.stringify([{
            "EnumName": this.EnumName,
            "FieldName": this.FieldName,
            "FieldType": this.FieldType,
            "IdEnum": "",
            "FilterRefDtoName": this.opt.RefWhere || '',
            "IsHead": this.opt.IsHead || this.opt.IsUserHeadRef,
            "IsPublic": false,
            "MaxLength": 500,
            "Precision": 0,
            "RefDTOName": this.opt.RefDTOName,
            "RefLinkField": "",
            "RefShowField": this.opt.RefShowField,
            "Title": this.title,
            "ValueFrom": this.opt.ValueFrom,
            "ViewID": 0,
            "VoucherName": this.opt.VoucherName || "SaleDelivery"
          }])
        })
        let refValueInfo;
        try {
          refValueInfo = data[0].RefValueList.RefValueInfo;
        } catch (e) {
          refValueInfo = [];
        }
        runInAction(() => {
          if (this.pageIndex != 1) {
            this.data = [...this.data, ...refValueInfo]
          } else {
            this.data = refValueInfo;
          }
          this.RefTitleInfo = data[0].RefTitleInfo;
          this.IsNextPage = data[0].IsNextPage;
          if (this.IsNextPage) {
            this.pageIndex = this.pageIndex + 1;
          }
        })
      } else if (this.EnumName) { // 枚举
        if (this.refRequestMethord) {
          data = await QueryApi.GetDropDownDataByMethod(this.refRequestParam, this.refRequestMethord);
          let tempData = { Items: [] }
          data[this.opt.listName].forEach(item => {
            tempData.Items.push({ Id: item.ID, Name: item.Name, Code: item.Code });
          })
          data = tempData;
        } else if (this.FieldName && this.FieldName.toLowerCase().startsWith('freeitem') && this.opt && this.opt.invId) {
          data = await QueryApi.GetInvFreeItemsDetails(this.FieldName, this.opt.invId);
        } else {
          data = await QueryApi.getEnumByName(this.EnumName);
        }
        console.log('data =>', data)
        runInAction(() => {
          this.title = data.Title;
          this.data = data.Items.filter(item => {
            let condition = item.CustomUse !== undefined ? !item.IsDelete && !item.CustomUse : !item.IsDelete;
            if (this.notShowIdOrCode.length) return condition && (this.notShowIdOrCode.indexOf(item.Id || item.ID || item.Code) < 0);
            return condition;
          });
          this.IsNextPage = false;
        });
      } else { // 参照
        const param = {
          "getauthby": 'dtoinfo',
          "searchItemCtrlId": this.opt.ID || '',
          "strDataSourceKey": this.opt.RefDataSource,
          "refObj": this.opt.RefDTOName,
          "strWhere": this.opt.RefWhereDTOID || this.opt.RefWhere || '',
          "whereParams": this.opt.whereParams || {},
          "codename": this.searchValue,
          "currentPage": this.pageIndex,
          "type": this.opt.IsHead || this.opt.IsHead == undefined || this.opt.IsUserHeadRef ? 'head' : 'detail',
          "pageSize": 20,
          "dropDownGridMatchMode": "4",
          "menuCode": ""
        }
        if (this.opt.showFields) {
          param.showFields = this.opt.showFields;
        }
        data = await QueryApi.GetDropDownData(param);
        console.log('data => ', data);
        let { Data: { compactDataTable, pagePara }, FieldType,SensitiveField } = data;
        
        if(SensitiveField){
          this.desensitizationFileds = [];
          for(let key in SensitiveField){
            if(SensitiveField[key]){
              this.desensitizationFileds.push(key);
            }
          }
        }
        // this.desensitizationFileds = ['OfficePhoneNo', 'MobilePhoneNo'];
        // compactDataTable.forEach(item=>{
        //   item['MobilePhoneNo'] = '176****3958';
        //   item['OfficePhoneNo'] = '633***8189';
        // })

        runInAction(() => {
          if (this.pageIndex != 0) {
            this.data = [...this.data, ...compactDataTable]
          } else {
            this.data = compactDataTable;
          }
          this.totalPageNum = pagePara.TotalPageNum;
          this.pageIndex = this.pageIndex + 1;
        })
      }
      return this.data.toJSON();
    } catch (err) {
      this.error = err.message;
    }
    runInAction(() => {
      this.loaded = true;
    });
  }

  setIsSelect = (data) => {
    if (!this.multiSelect) {
      return;
    }
    if (data && data.length > 0) {
      data.forEach(item => {
        item.selected = false;
        this.selecteds.forEach(selected => {
          if ((selected.ID && selected.ID == item.ID) ||
            (selected.Id && selected.Id == item.Id)) {
            item.selected = true;
          }
        })
      })
    }
  }

  static getInstance() {
    if (!this.instance) {
      this.instance = new RefModel();
    }
    return this.instance;
  }
}
export default RefModel;
